import React from 'react';
import { graphql } from 'gatsby';
import { MDXRenderer } from "gatsby-plugin-mdx"
import Link from 'gatsby-link';
import Img from 'gatsby-image';


import Layout from 'components/Layout';
import SEO from 'components/SEO';
import Container from 'components/ui/Container';
import TitleSection from 'components/ui/TitleSection';
import CallOut from 'components/CallOut';
import { ImageSharpFluid } from 'helpers/definitions';

import * as Styled from './styles';

interface Post {
  body: React.ReactNode;
  fields: {
    slug: string;
  };
  frontmatter: {
    title: string;
    date: string;
    cover: {
      childImageSharp: {
        fluid: ImageSharpFluid;
      };
     
    }
    socialcard?: string
  };
}

interface Props {
  data: {
    mdx: Post;
  };
  pageContext: {
    slug: string;
    next: Post;
    previous: Post;
  };
}


const BlogPost: React.FC<Props> = ({ data, pageContext }) => {
  const post = data.mdx;
  const { previous, next, slug } = pageContext;

  return (
    <Layout slug={slug}>
      <SEO title={post.frontmatter.title} slug={slug}/>
      <Container section>
        {post.frontmatter.cover && <Styled.Image>
            <Img fluid={post.frontmatter.cover.childImageSharp.fluid} alt={post.frontmatter.title} />
          </Styled.Image>}
        <TitleSection title={post.frontmatter.title} subtitle={post.frontmatter.date} />
        <Styled.Post>
          <MDXRenderer>{post.body}</MDXRenderer>
        </Styled.Post>
        <CallOut>
          Hi, I'm Glenn! 👋 I've spent most of my career working with or at startups. I'm currently the
          Director of Product @ <a href="https://www.ockam.io/">Ockam</a> where I'm helping developers
          build applications and systems that are secure-by-design. It's time we started securely connecting 
          apps, not networks.<br/><br/>
          
          Previously I led the Terraform product team @ HashiCorp, where we launched Terraform Cloud and set
          the stage for a successful IPO. Prior to that I was part of the Startup Team @ AWS, and earlier
          still an early employee @ Heroku. I've also invested in a couple of dozen early stage startups.
        </CallOut>
        {/* <Styled.Links>
          <span>
            {previous && (
              <Link to={previous.fields.slug} rel="previous">
                ← {previous.frontmatter.title}
              </Link>
            )}
          </span>
          <span>
            {next && (
              <Link to={next.fields.slug} rel="next">
                {next.frontmatter.title} →
              </Link>
            )}
          </span>
        </Styled.Links> */}
      </Container>
    </Layout>
  );
};

export default BlogPost;

export const query = graphql`
  query BlogPostBySlug($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      body
      frontmatter {
        title
        date(formatString: "MMM DD, YYYY")
        cover {
          childImageSharp {
            fluid(maxWidth: 800) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;
